import React, { ReactNode, useState } from "react";
import { Tooltip } from "@mui/material";
import { isTextEllipsed } from "utils/general_utils";

interface EllipsisTooltipProps {
  children: ReactNode;
  tooltip?: string;
  align?: "flex-start" | "center" | "flex-end";
  hide?: boolean;
}

export const EllipsisTooltip = ({
  children,
  tooltip,
  align = "flex-start",
  hide = true,
}: EllipsisTooltipProps) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipContent, setTooltipContent] = useState<string>("");

  const handleMouseEnter = (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.currentTarget;
    if (tooltip) return;

    if (isTextEllipsed(target)) {
      setShowTooltip(true);
      setTooltipContent(target.textContent || "");
    } else {
      setTooltipContent("");
    }
  };

  return (
    <Tooltip
      title={tooltip ? tooltip : showTooltip ? tooltipContent : ""}
      placement="top"
      arrow
      PopperProps={{
        style: { zIndex: 10000 },
      }}
    >
      <span
        onMouseEnter={handleMouseEnter}
        style={{
          display: "inline-block",
          justifyContent: align,
          maxWidth: "100%",
          whiteSpace: hide ? "nowrap" : "normal",
          overflow: hide ? "hidden" : "unset",
          textOverflow: "ellipsis",
        }}
      >
        {children}
      </span>
    </Tooltip>
  );
};
